import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import './common/extensions/stringExtension';
import 'dayjs/locale/pt';
import 'dayjs/locale/fr';
import 'moment/locale/fr';
import 'moment/locale/pt';
import Logger from './common/services/Logger';
import { LOGGER_LOG_TYPE } from './Config';

dayjs.extend(utc);
dayjs.extend(timezone);

// Global JS error capture: uncaught errors and unhandled promise rejections are forwarded
// to the backend (which relays them to the external logging API).
window.addEventListener('error', (event) => {
    Logger.error(LOGGER_LOG_TYPE.JS, event.message ?? 'Uncaught error', {
        stack: event.error?.stack,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
        error: event.error
    });
});

window.addEventListener('unhandledrejection', (event) => {
    const reason: any = event.reason;
    Logger.error(LOGGER_LOG_TYPE.JS, reason?.message ?? 'Unhandled promise rejection', {
        stack: reason?.stack,
        reason
    });
});

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
